<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"></ng-progress>
<div class="subBlockContainer left-mood">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()" 
      [showAdd]="true"
      [titleAdd]="'New Digital Wallet'"
      [disableAdd]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
      [tooltipAdd]="'Requires Purchasing Permissions'"
      [tooltipDisabledAdd]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
      (addEvent)="newDigitalWallet()" 
    ></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
            {{title}}
            <div id="buttonNew" class="basic-icon add-icon" (click)="newDigitalWallet()"></div>
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->

        <!-- Dispaly all digital wallets -->
        <div id="list-payment">
          <div class="noResult-wrapper OrignalResult" *ngIf="loadContent && !customerPayments?.length">
              <div class="top-divider"></div>
              <div><img src="../images/new_ui/no-wallet.png"></div>
              <div id="reason">Your digital wallet is empty.</div>
              <button
                id="addPaymentBtn"
                class="button button-red button-mid"
                [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                matTooltip="Requires Purchasing Permissions"
                (click)="newDigitalWallet()"
              >Create new</button>
          </div>

          <ng-container *ngIf="loadContent && customerPayments?.length">
            <div class="row filter-wrapper">
                <div class="col-md-12">
                    <div class="searchInputGroup">
                        <div class="searchIcon">
                            <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="filterInput" (ngModelChange)="onChange()">
                    </div>
                </div>
            </div>
            <div class="top-divider"></div>
            <div class="child-body">
              <div class="shared-outer-wrapper" *ngFor="let payment of customerPayments | TableFilterMultiple: [ 'out_account_name' ]: filterInput;let i = index">
                <section>
                    <!-- <div class="edit-button"></div> -->
                    <div class="red-text bold-text">Digital Wallet ID: {{payment.out_customer_number}}</div>
                    <!-- CUSTOMER NAME -->
                    <div class="payment-name-wrapper">{{payment.out_account_name}}</div>
                    <!-- PAYMENT METHOD -->
                    <div>{{payment.out_payment_method}}</div>
                    <!-- DETAILS -->
                    <div>
                      <span *ngIf="payment.out_masked_card_number">{{payment.out_masked_card_number}}</span>
                      <span *ngIf="payment.out_expiry">{{payment.out_expiry}}</span>
                      <span *ngIf="payment.out_account_no">{{payment.out_account_no}}</span>
                    </div>
                    <div>
                      {{payment.out_access}}
                    </div>
                    <div>{{payment.out_notes}}</div>
                    <div class="checkbox-center" [id]="payment.out_customer_number" >
                        <mat-slide-toggle
                          [checked]="payment.out_valid === 'Y'"
                          (change)="enableDisablePaywayCustomer($event,payment)"
                          [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                          [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                          matTooltip="Requires Purchasing Permissions"
                          class="activesuspend enableToggle">
                        </mat-slide-toggle>
                    </div>
                    <span style="float: right; margin-top: -95px;">
                      <img 
                        style="width: 20px; height: 20px;"
                        [src]="'../images/site-icons/' + (payment?.out_access == 'C' ? 'company-building-red.svg' : 'my-account/end-user-info.svg')"
                        [matTooltip]="payment?.out_account_name + ': ' + (payment?.out_access == 'C' ? 'Shared' : 'Personal')"
                      >
                    </span>
                    <!-- <div [id]="payment.out_customer_number" class="button button-red button-small delete" (click)="deletePayment(payment)">DELETE</div> -->
                  <!-- <div [id]="payment.out_customer_number" class="button button-red button-small delete" (click)="deletePayment(payment)">DELETE</div> -->
                </section>
              </div>
            </div>
            <ng-container *ngIf="hasEmptyFilterResult">
                <div class="noResult-wrapper">
                    <div><img src="../images/new_ui/no-wallet.png"></div>
                    <div id="reason">Your digital wallet is empty.</div>
                    <button class="button button-red button-large" (click)="newDigitalWallet()"
                            [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                            matTooltip="Requires Purchasing Permissions"
                    >Create now</button>
                </div>
            </ng-container>

          </ng-container>
        </div>

          <!-- Create a new digital wallet -->

    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [isScrolled]="currentUrl?.includes('openorders')" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>


<div class="subBlockContainer" *ngIf="editMood || addMood" [class.widerIframe]="!paymentForm">
  <div class="subBlockContent">
    <child-header [title]="editMood ? 'Edit Digital Wallet' : (addMood ? 'New Digital Wallet' : '') " (closeEvent)="closeRightPanel()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
              <!-- <div *ngIf="editMood" class="title blade-title-font">
                Edit Digital Wallet
              </div>
              <div *ngIf="addMood" class="title blade-title-font">
                New Digital Wallet
              </div>
              <i class="material-icons closebutton-pullfloat-right" (click)="closeRightPanel()">close</i> -->
          <!-- Step One -->
          <div class="form-container" [formGroup]="paymentGroup" *ngIf="paymentForm">
            <div formGroupName="newPaymentGroup" class="new-payment">
              <div class="payment-row">
                <label class="payment-row-title">Name Your Payment Option *</label>
                <div class="payment-row-control">
                    <input type="text" placeholder="e.g. Bank Corporate Credit Card" onfocus="this.placeholder=''" onblur="this.placeholder='e.g. Bank Corporate Credit Card'" class="customerNameValidate" formControlName="customerName" (blur)="isNotValidField('newPaymentGroup.customerName', '.customerNameValidate')" />
                </div>
              </div>

              <div class="payment-row">
                <div class="payment-row-control">
                </div>
              </div>
              <div class="payment-row">
                <div class="payment-row-control">
                  <mat-slide-toggle formControlName="paywayPersonalUse">
                    <span [ngbTooltip]="companyWideUseTip" placement="top" class="payment-row-title">
                      Company wide use
                      <img class="attention-img" src="../images/new_ui/attention.png">
                    </span>
                  </mat-slide-toggle>
                </div>
              </div>
              <div class="payment-row">
                <div class="payment-row-control">
                  <label>Max Authorised AMT</label>
                  <span [ngbTooltip]="amtTip" placement="top" class="display-inline-block">
                      <img class="attention-img" src="../images/new_ui/attention.png">
                  </span>
                  <input type="text" id="maxAuthorisedAmount" class="amtValidate" formControlName="maxAuthorisedAmount" />
                </div>
              </div>
            </div>
            <div class="button-center">
              <button type="button" id="nextBtn" class="button button-red button-large" (click)="registerPayment()">Save</button>
            </div>
          </div>
          <div id="msg" style="visibility: hidden;"></div>
          <div id="card_type" style="visibility: hidden;"></div>

          <!-- Step Two -->
          <div class="payment-setup" *ngIf="!paymentForm">
            <div class="page-title-description">
              The information you provide here is stored directly with Westpac Banking Corporation to ensure all PCI standards complied with.
            </div>
            <div class="payment-option" ngbRadioGroup name="radioBasic" [(ngModel)]="selectedPaymentMethod">
              <label ngbButtonLabel>
                <input type="radio" ngbButton value="creditcard" class="cc" (click)="showCCForm()">
                <span>CREDIT CARD</span>
              </label>
              <label ngbButtonLabel>
                <input type="radio" ngbButton value="bankaccount" class="ba" (click)="showBAForm()">
                <span>BANK ACCOUNT</span>
              </label>
            </div>
            <div class="credit-card" *ngIf="selectedPaymentMethod == 'creditcard'">
              <div class="align-center">
                <form>
                  <div id="payway-credit-card"></div>
                </form>
                <button class="button button-red button-large margin-t-x15" id="payway-cc-submit" (click)="paywayLanding('cc')" disabled>Register</button>
                <button class="button payment-back" (click)="backToForm()">Previous</button>
              </div>
            </div>
            <div class="bank-account" *ngIf="selectedPaymentMethod == 'bankaccount'">
              <div class="align-center">
                <form>
                  <div id="payway-bank-account"></div>
                </form>
                <button class="button button-red button-large" id="payway-ba-submit" (click)="paywayLanding('ba')" disabled>Register</button>
                <button class="button payment-back" (click)="backToForm()">Previous</button>
              </div>
            </div>

          </div>
      </div>
    </div>
  </div>
</div>

  <ng-template #companyWideUseTip>
    <div class="padding-x10">
      <div class="tooltip-title">Show this payment method everyone in your company to use</div>
    </div>
  </ng-template>

  <ng-template #amtTip>
    <div class="padding-x10">
      <div class="tooltip-title">Maximum amount can be used to make automatic payments</div>
    </div>
  </ng-template>
